import { FcsFlag } from '../unleash'

export const FlagsAccount = {
  pickup_dashboard_liberta_my_whitelist: new FcsFlag.Flag(false)
}

export function initFlagsAccount(): void {
  FcsFlag.register('account', FlagsAccount)
}

export function isMyWhitelisted(): boolean {
  return FlagsAccount.pickup_dashboard_liberta_my_whitelist.isEnabled()
}
